import { useState } from "react";
import BannerComp from "../components/BannerComp";
import CaseStudyCard from "../components/CaseStudyCard";
import Seo from "../components/Seo";
import { caseStudies } from "../data/caseStudies";
import { createBreadcrumbSchema, createWebPageSchema } from "../lib/seo";
import styles from "./CaseStudy.module.css";

const INITIAL_VISIBLE_COUNT = 6;
const LOAD_MORE_COUNT = 3;

const seo = {
  title: "Medical Billing & RCM Case Studies | PSP RCM Success Stories",
  description:
    "Explore real-world case studies showcasing PSP RCM's expertise in medical billing, revenue cycle management, and practice optimization.",
  keywords:
    "medical billing case studies, RCM case studies, healthcare revenue cycle success stories, PSP RCM case studies",
  schema: [
    createWebPageSchema({
      path: "/case-studies",
      title: "Medical Billing & RCM Case Studies",
      description:
        "Explore real-world case studies showcasing PSP RCM's expertise in medical billing, revenue cycle management, and practice optimization.",
      type: "CaseStudy",
    }),
    createBreadcrumbSchema(
      "/case-studies",
      "Medical Billing & RCM Case Studies",
    ),
  ],
};

export default function CaseStudy() {
  const [visibleCount, setVisibleCount] = useState(INITIAL_VISIBLE_COUNT);
  const visibleCaseStudies = caseStudies.slice(0, visibleCount);
  const hasMore = visibleCount < caseStudies.length;

  return (
    <>
      <Seo
        title={seo.title}
        metaTitle={seo.title}
        description={seo.description}
        keywords={seo.keywords}
        canonicalPath="/case-studies"
        schema={seo.schema}
      />
      <BannerComp
        heading="Real Results, Real Impact"
        paragraph="Discover how PSP RCM has helped healthcare practices optimize their revenue cycles, reduce denials, and improve financial performance."
        BannerBgImg="/pages-banner.webp"
        centered
      />

      <section className={styles.section}>
        <div className="container">
          <div className={styles.intro}>
            <span className={styles.eyebrow}>Case Study Library</span>
            <h2>
              Proven Solutions for Medical Billing & Revenue Cycle Challenges
            </h2>
            <p>
              Each case study highlights specific challenges, solutions
              implemented, and measurable results achieved for healthcare
              practices.
            </p>
          </div>

          <div className={styles.grid}>
            {visibleCaseStudies.map((caseStudy) => (
              <CaseStudyCard key={caseStudy.slug} caseStudy={caseStudy} />
            ))}
          </div>

          {hasMore ? (
            <div className={styles.actions}>
              <button
                type="button"
                className={styles.loadMore}
                onClick={() =>
                  setVisibleCount((count) => count + LOAD_MORE_COUNT)
                }
              >
                Load More Case Studies
              </button>
            </div>
          ) : null}
        </div>
      </section>
    </>
  );
}
